import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IRoutePermission } from '../../utils/constants/interfaces';
import { Helpers } from '../../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleDown, faToolbox } from '@fortawesome/free-solid-svg-icons';
import { useStoreContext } from '../../store/store';
import FragmentContainer from '../../components/ui/FragmentContainer/FragmentContainer';

export const Sidebar = (props: { sidebarMenu: IRoutePermission[] }) => {
  const { settings } = useStoreContext();
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);

  const toggleSubMenu = (menuText: string | undefined) => {
    if (!menuText) return;
    setExpandedMenus((prev) =>
      prev.includes(menuText) ? prev.filter((item) => item !== menuText) : [...prev, menuText]
    );
  };

  const renderMenuItem = (item: IRoutePermission) => {
    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = item.text ? expandedMenus.includes(item.text) : false;

    return (
      <li key={item.text}>
        {hasChildren ? (
          <div className="submenu-container">
            <div
              className="list-group-item list-group-item-action"
              onClick={() => toggleSubMenu(item.text)}>
              {item.iconClass && <FontAwesomeIcon className="menu-icon" icon={item.iconClass} />}
              <span className="menu-text">
                {item.text}
                <FontAwesomeIcon
                  className="menu-arrow-icon"
                  icon={isExpanded ? faAngleDown : faAngleRight}
                />
              </span>
            </div>
            {isExpanded && item.children && (
              <ul className="submenu">
                {item.children.map((child) => (
                  <li key={child.text}>
                    <Link
                      to={child.path}
                      className="list-group-item list-group-item-action submenu-item">
                      {child.iconClass && (
                        <FontAwesomeIcon className="menu-icon" icon={child.iconClass} />
                      )}
                      <span className="menu-text">
                        {child.text}
                        <FontAwesomeIcon className="menu-arrow-icon" icon={faAngleRight} />
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <Link to={item.path} className="list-group-item list-group-item-action">
            {item.iconClass && <FontAwesomeIcon className="menu-icon" icon={item.iconClass} />}
            <span className="menu-text">
              {item.text}
              <FontAwesomeIcon className="menu-arrow-icon" icon={faAngleRight} />
            </span>
          </Link>
        )}
      </li>
    );
  };

  return (
    <>
      <div id="sidebar-wrapper" className="border-end">
        <div>
          <ul className="list-group list-group-flush">
            {props.sidebarMenu && props.sidebarMenu.map(renderMenuItem)}
            <FragmentContainer visible={Helpers.isRunningLocal()}></FragmentContainer>
          </ul>
        </div>
        <div className="sidebar-footer">
          <div className="app-version">{settings.applicationVersion}</div>
        </div>
      </div>
    </>
  );
};
